module.exports = __webpack_public_path__ + "static/media/dennis.8048b42c.gif";